import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React from 'react';
import { Alert, Badge, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useToast } from 'context/providers/ToastProvider';

const ModalAsignarModuloALicencia = ({
    modalStateAsignarRenovacion,
    setModalStateAsignarRenovacion,
    licenciasRenovacionModal,
    selectedLicenciaRenovacion,
    setSelectedLicenciaRenovacion,
    tipoRenovacion,
    guardarAsignacionRenovacion
}) => {
    const { showErrorToast } = useToast();

    const handleCloseModal = () => {
        setModalStateAsignarRenovacion({
            isOpen: false,
            isLoading: true,
            idOrdenDetalle: null,
            vCodigoBarras: null
        });
        setSelectedLicenciaRenovacion(null);
    };

    const handleAsignarRenovacion = () => {
        if (!selectedLicenciaRenovacion) {
            showErrorToast("Debe seleccionar una licencia");
            return;
        }
        guardarAsignacionRenovacion(
            selectedLicenciaRenovacion,
            modalStateAsignarRenovacion.idOrdenDetalle
        );
    };

    if (!modalStateAsignarRenovacion.isOpen) return null;

    return (
        <Modal
            show={modalStateAsignarRenovacion.isOpen}
            onHide={handleCloseModal}
            size="md"
            backdrop="static"
            aria-labelledby="modal-renovacion-title"
            centered
        >
            <Modal.Header>
                <Modal.Title id="modal-renovacion-title">

                    {tipoRenovacion ? (
                        <>
                            Asignar Licencia para módulo con renovación
                            <Badge bg="info" className="ms-2">
                                {tipoRenovacion}
                            </Badge>
                        </>
                    ) : (
                        <>Asignar Licencia para módulo adicional</>
                    )}

                </Modal.Title>
                <FalconCloseButton
                    className="btn btn-circle btn-sm transition-base p-0"
                    onClick={handleCloseModal}
                />
            </Modal.Header>
            <Modal.Body>
                {modalStateAsignarRenovacion.isLoading ? (
                    <Row>
                        <Col className="text-center py-4">
                            <Spinner animation="border" role="status" variant="primary">
                                <span className="visually-hidden">Cargando...</span>
                            </Spinner>
                            <p className="mt-2 text-muted">Cargando licencias disponibles...</p>
                        </Col>
                    </Row>
                ) : (
                    <>
                        {licenciasRenovacionModal && licenciasRenovacionModal.length > 0 ? (
                            <>
                                <Row className="mb-3">
                                    <Col>
                                        <div className="mb-3">
                                            <strong>Producto:</strong> {modalStateAsignarRenovacion.vCodigoBarras}
                                            <hr />
                                        </div>
                                        <p className="text-muted mb-3">
                                            Seleccione la licencia activa que desea:
                                        </p>
                                        <Form.Select
                                            aria-label="Selecciona la licencia"
                                            style={{ cursor: "pointer" }}
                                            onChange={e => setSelectedLicenciaRenovacion(e.target.value)}
                                            value={selectedLicenciaRenovacion || ''}
                                        >
                                            <option value="">SELECCIONE UNA LICENCIA ACTIVA</option>
                                            {licenciasRenovacionModal.map((licencia) => (
                                                <option value={licencia.idLicencia} key={licencia.idLicencia}>
                                                    #{licencia.idLicencia} - {licencia.vUUIDLicencia}
                                                    {licencia.dFinLicenciaUso && (
                                                        <> (Vence: {new Date(licencia.dFinLicenciaUso).toLocaleDateString('es-MX')})</>
                                                    )}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <Row>
                                <Col>
                                    <Alert variant="warning">
                                        <Alert.Heading>
                                            <i className="fas fa-exclamation-triangle me-2"></i>
                                            Sin licencias disponibles
                                        </Alert.Heading>
                                        <p className="mb-0">
                                            El cliente no tiene licencias activas que puedan ser renovadas con este producto.
                                        </p>
                                    </Alert>
                                </Col>
                            </Row>
                        )}
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button
                    onClick={handleCloseModal}
                    variant="secondary"
                >
                    Cancelar
                </Button>

                {licenciasRenovacionModal && licenciasRenovacionModal.length > 0 && (
                    <Button
                        onClick={handleAsignarRenovacion}
                        variant="success"
                        disabled={modalStateAsignarRenovacion.isLoading}
                    >
                        <i className="fas fa-sync me-2"></i>
                        Asignar Renovación
                    </Button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

ModalAsignarModuloALicencia.propTypes = {
    modalStateAsignarRenovacion: PropTypes.shape({
        isOpen: PropTypes.bool.isRequired,
        isLoading: PropTypes.bool.isRequired,
        idOrdenDetalle: PropTypes.number,
        vCodigoBarras: PropTypes.string
    }).isRequired,
    setModalStateAsignarRenovacion: PropTypes.func.isRequired,
    licenciasRenovacionModal: PropTypes.array.isRequired,
    selectedLicenciaRenovacion: PropTypes.string,
    setSelectedLicenciaRenovacion: PropTypes.func.isRequired,
    tipoRenovacion: PropTypes.string,
    guardarAsignacionRenovacion: PropTypes.func.isRequired
};

export default ModalAsignarModuloALicencia;